import { css } from 'styled-components'

const lstPxs = [115, 290, 275, 150]

const gridArr = lstPxs.map(item => `${item}px`)

const extendStylesTable = css`
    .header,
    .row {
        grid-template-columns: ${gridArr.join(' ')};
    }
`

const extendStylesOffice = css`
    width: 268px;
`

export { extendStylesTable, extendStylesOffice }
